/**
 * Centralized runtime configuration for the dashboard frontend.
 *
 * All values are read from the environment via the CRA-safe `readEnv` helper
 * (webpack DefinePlugin inlines `process.env.<NAME>`), with safe fallbacks so
 * local dev keeps working. NO SECRETS live here — only public URLs / identifiers.
 * The Supabase key is the PUBLIC anon key (safe to inline); the service-role key
 * is never referenced in the browser bundle.
 *
 * NOTE (P0 fix): this module previously read env through a
 * `(typeof process !== "undefined" && process.env) || {}` alias, which resolves
 * to `{}` in the webpack-5 browser bundle (bare `process` is undefined there) —
 * so every configured value silently fell back to its default in the built app.
 * It now uses `readEnv` (see src/shared/env.js).
 */

import { readEnv, ENV_RESOLVED } from "./env";

/** Supabase project REST/Auth base URL (public identifier). */
export const SUPABASE_URL =
  readEnv("REACT_APP_SUPABASE_URL") || "https://gufmotkoeoqvmxjeqbmw.supabase.co";

/** Supabase PUBLIC anon key (safe to expose; RLS enforces access). Empty => Setup screen. */
export const SUPABASE_ANON_KEY = readEnv("REACT_APP_SUPABASE_ANON_KEY") || "";

/**
 * n8n webhooks for the (frozen) Offer Creation module. These currently point at
 * a personal n8n tenant + a `test-offer` webhook; move to an org-owned tenant
 * at cutover by setting the env vars. Fallbacks preserve today's behavior.
 */
export const N8N_IMPORT_URL =
  readEnv("REACT_APP_N8N_IMPORT_URL") || "https://mostafakhaleddd.app.n8n.cloud/webhook/test-offer";
export const N8N_EVAL_URL =
  readEnv("REACT_APP_N8N_EVAL_URL") || "https://mostafakhaleddd.app.n8n.cloud/webhook/8c48a9a7-b371-4417-a4cf-baf156977fcc";
export const N8N_PHOTO_URL =
  readEnv("REACT_APP_N8N_PHOTO_URL") || "https://mostafakhaleddd.app.n8n.cloud/webhook/72211ff9-f091-4917-89e4-0f07bd6d53d7";

/**
 * Competitive Intelligence local-daemon health endpoint (POSTPONED feature).
 * Env-driven; set REACT_APP_CI_HEALTH_URL="" to disable polling. `readEnv`
 * returns "" (not the fallback) when the var is explicitly set to empty, so an
 * empty string genuinely disables polling.
 */
export const CI_HEALTH_URL = (() => {
  const v = readEnv("REACT_APP_CI_HEALTH_URL");
  return v === undefined ? "http://localhost:4001/health" : v;
})();

// Browser assertion (practical): if the env token was not inlined, readEnv would
// return undefined for everything and configuration would silently use fallbacks.
// Fail loudly rather than shipping a mis-wired build. Guarded so tests stay quiet.
if (!ENV_RESOLVED && typeof console !== "undefined" && console.error) {
  console.error("[config] build-time environment did not resolve — using fallback values only. Check the build's DefinePlugin / env access pattern.");
}
